export default "__VITE_ASSET__CGSSaHYu__"